module.exports = new __parcel__URL__("RenewableEnergySnow.e8737722.png").toString();